import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../shared/dialog/confirm-modal/confirm-dialog.component';
import { IOperatorsOptions } from '../../../../shared/models/interfaces/typology.interface';
import { SharedModule } from '../../../../shared/shared.module';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperatorShiftService } from '../../../../shared/services/operator-shift.service';
import { IDeatilOperatorShift, IUpdateOperatorShift } from '../../../../shared/models/interfaces/operator-shift.interface';
import { tap } from 'rxjs';
import { NotificationService } from '../../../../core/services/notification.service';

interface IUpdate {
 operator: IOperatorsOptions;
 isEdit:boolean;
 detailShift?:IDeatilOperatorShift
}

@Component({
  selector: 'ngb-operator-shift-update-dialog',
  templateUrl: './operator-shift-update-dialog.component.html',
  styleUrl: './operator-shift-update-dialog.component.scss',
  imports: [
    SharedModule
  ],
})
export class OperatorShiftUpdateDialogComponent implements OnInit {

  form:FormGroup;

  readonly minDate = new Date ();

  readonly data = inject<IUpdate>(MAT_DIALOG_DATA);
  readonly dialogRef : MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef<ConfirmDialogComponent>);
  private readonly _fb :FormBuilder = inject(FormBuilder);
  private readonly operatorShiftService :OperatorShiftService = inject(OperatorShiftService);
  private readonly  _notificationService: NotificationService = inject(NotificationService);

  ngOnInit(): void {
    const startDate = this.data.isEdit ? this.data?.detailShift?.shiftDate : null;
    const startTime = this.data.isEdit ? this.data?.detailShift?.startTime : null;
    const endTime = this.data.isEdit ? this.data?.detailShift?.endTime : null;

    this.form = this._fb.group({
      startDate:this._fb.control(startDate,Validators.required),
      moreDays:this._fb.control(false),
      endDate:this._fb.control(null),
      startTime:this._fb.control(startTime,Validators.required),
      endTime:this._fb.control(endTime,Validators.required)
    })
  }

  onConfirm(){
    if(this.form.invalid){
      return this.form.markAllAsTouched();
    }

    let {startDate,endDate,startTime,endTime}= this.form.getRawValue();

    const body:IUpdateOperatorShift = {
      operatorId:this.data.operator.id,
      shiftDates: this.generaIntervalloDate(startDate,endDate),
      oldStartTime: this.data?.detailShift?.startTime ? this.data?.detailShift?.startTime :undefined,
      oldEndTime:this.data?.detailShift?.endTime ? this.data?.detailShift?.endTime :undefined,
      startTime:this.formattingTime(startTime),
      endTime:this.formattingTime(endTime),
    }

    if(!this.data.isEdit){
      this.operatorShiftService.createOperatorShift(body).pipe(
        tap(() => {
          this._notificationService.successSnackBar('Il turno è stato creato con successo.');
          this.dialogRef.close({onClose:false});
        })
      ).subscribe();
    }else{
      this.operatorShiftService.editOperatorShift(body).pipe(
        tap(() => { 
          this._notificationService.successSnackBar('Il turno è stato modificato con successo.');
          this.dialogRef.close({onClose:false});
        })
      ).subscribe();
    }
  }

  formattingTime(time: string): string {
    // Se è già nel formato HH:mm:ss, restituiscilo com'è
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(time)) {
      return time.length === 5 ? `${time}:00` : time; // se "13:30", diventa "13:30:00"
    }

    // Altrimenti gestisci formato "13.30"
    const [hoursOpening, minutesOpening] = time.split('.');
    const hoursFinalOpening = hoursOpening.padStart(2, '0');
    const minutesFianlOpening = (minutesOpening || '00').padStart(2, '0');
    return `${hoursFinalOpening}:${minutesFianlOpening}:00`;
  }

  generaIntervalloDate(dataInizio: Date, dataFine?: Date): string[] {
    if (dataFine) {
      const result: string[] = [];
      const giorniTotali = Math.floor( (dataFine.getTime() - dataInizio.getTime()) / (1000 * 60 * 60 * 24));

      for (let i = 0; i <= giorniTotali; i++) {
        const data = new Date(dataInizio);
        data.setDate(data.getDate() + i);
        result.push(this.formatDate(data));
      }

      return result;
    } else {
      return [this.formatDate(dataInizio)];
    }
  }

  formatDate(data: Date): string {
    const date = new Date(data)
    const yyyy = date?.getFullYear();
    const mm = String(date?.getMonth() + 1).padStart(2, '0');
    const dd = String(date?.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

}
